export const assets = [
    {
        name: 'Producto',
        value: 'PRODUCT'
    },
    {
        name: 'Instrumento',
        value: 'INSTRUMENT'
    }
]